module.exports = __webpack_public_path__ + "static/img/6areaB_11.b507e69.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_11.png
// module id = 1213
// module chunks = 1